// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

var default_blacklist_item = {
  key: "0",
  value: "-1",
  text: "--------Please select a blacklisting reason--------"
};

var blacklist_items_1 = {
  hd: {
    key: "1",
    value: "FAKE_CUSTOMER",
    text: "Fake Customer"
  },
  tl: {
    hd: {
      key: "2",
      value: "CUSTOMER_MISBEHAVIOUR",
      text: "Customer Misbehaviour"
    },
    tl: {
      hd: {
        key: "3",
        value: "DUPLICATE_ACCOUNT",
        text: "Duplicate Account"
      },
      tl: {
        hd: {
          key: "4",
          value: "UNCLEARED_DUES",
          text: "Uncleared dues"
        },
        tl: {
          hd: {
            key: "5",
            value: "BALANCE_LOW",
            text: "Dues above 100 - checked after 24 hours"
          },
          tl: {
            hd: {
              key: "6",
              value: "EXCEEDED_ORDER_CANCELLATIONS",
              text: "Exceeded order cancellations for today"
            },
            tl: {
              hd: {
                key: "7",
                value: "CUSTOMER_UNDERPAYMENT",
                text: "Customer underpayment"
              },
              tl: {
                hd: {
                  key: "8",
                  value: "CUSTOMER_UNDERPAYMENT_MORE_THAN_TWO_ORDERS",
                  text: "Customer underpayment for more than two orders"
                },
                tl: {
                  hd: {
                    key: "9",
                    value: "FREQUENT_ORDER_CANCELLATIONS",
                    text: "Frequent cancellations"
                  },
                  tl: {
                    hd: {
                      key: "10",
                      value: "ORDER_UNDERPAYMENT",
                      text: "Order Underpayment"
                    },
                    tl: {
                      hd: {
                        key: "11",
                        value: "BALANCE_VERY_LOW_PL",
                        text: "Dues above 400"
                      },
                      tl: {
                        hd: {
                          key: "12",
                          value: "CUSTOMER_ABUSE",
                          text: "Customer Abuse"
                        },
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

var blacklist_items = {
  hd: default_blacklist_item,
  tl: blacklist_items_1
};

function getSelectedItem(select_items_list, value) {
  return Belt_Option.getWithDefault(Belt_List.getBy(select_items_list, (function (item) {
                    return item.value === value;
                  })), default_blacklist_item);
}

var cust_type_items = {
  hd: {
    key: "1",
    value: "Shop",
    text: "Shop"
  },
  tl: {
    hd: {
      key: "2",
      value: "SME",
      text: "SME"
    },
    tl: {
      hd: {
        key: "3",
        value: "Insti_with_contracted_engagement",
        text: "Insti_with_contracted_engagement"
      },
      tl: {
        hd: {
          key: "4",
          value: "Insti_with_mg_engagement",
          text: "Insti_with_mg_engagement"
        },
        tl: {
          hd: {
            key: "5",
            value: "Retailer",
            text: "Retailer"
          },
          tl: {
            hd: {
              key: "6",
              value: "Enterprise",
              text: "Enterprise"
            },
            tl: {
              hd: {
                key: "7",
                value: "Distributor/Wholesaler",
                text: "Distributor/Wholesaler"
              },
              tl: {
                hd: {
                  key: "8",
                  value: "Transporter",
                  text: "Transporter"
                },
                tl: {
                  hd: {
                    key: "9",
                    value: "Partloading(DO NOT USE)",
                    text: "Partloading(DO NOT USE)"
                  },
                  tl: {
                    hd: {
                      key: "10",
                      value: "Manufacturer",
                      text: "Manufacturer"
                    },
                    tl: {
                      hd: {
                        key: "11",
                        value: "Contractor",
                        text: "Contractor"
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

var reg_status_items = {
  hd: {
    key: "1",
    value: "non_private_ltd",
    text: "Non private ltd"
  },
  tl: {
    hd: {
      key: "2",
      value: "private_ltd",
      text: "Private ltd"
    },
    tl: /* [] */0
  }
};

var radio_items = {
  hd: {
    label: "Yes",
    value: "true"
  },
  tl: {
    hd: {
      label: "No",
      value: "false"
    },
    tl: /* [] */0
  }
};

export {
  cust_type_items ,
  reg_status_items ,
  default_blacklist_item ,
  blacklist_items ,
  getSelectedItem ,
  radio_items ,
  
}
/* No side effect */
